export const ISOLVED_WHOLESALE = "ISOLVED_WHOLESALE";
export const LEGACY_NOBILL = "LEGACY_NOBILL";
export const STRIPE = "STRIPE";
